import { render, staticRenderFns } from "./EmojiItem.vue?vue&type=template&id=25b9dea2&scoped=true"
import script from "./EmojiItem.vue?vue&type=script&lang=js"
export * from "./EmojiItem.vue?vue&type=script&lang=js"
import style0 from "./EmojiItem.vue?vue&type=style&index=0&id=25b9dea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b9dea2",
  null
  
)

export default component.exports